<template>
	<div>
		<div v-if="auth">
			<div class="mt-2 text-center">
				<v-btn v-if="area === 'admin'" small outlined color="secondary" width="200" @click="() => { manualDialog = true; fillManualFieldsFromSiteContent() }">
					تکمیل اطلاعات قرارداد
				</v-btn>
			</div>
			<div class="mt-2 text-center">
				<v-btn small outlined color="secondary" @click="openCustomerContract" width="200">
					مشاهده قرارداد
				</v-btn>
			</div>
			<div class="mt-2 text-justify contract" v-if="auth.tag" v-html="auth.tag">

			</div>
		</div>

		<v-divider v-if="auth" class="my-4"></v-divider>

		<div v-if="auth">
			<div class="mb-2">
				<div class="text-center font-weight-bold">ضامن‌ها</div>
			</div>
			<div v-if="guarantors.length">
				<v-row v-for="(tp, index) in guarantors" :key="tp.id + index" style="border-bottom: 1px dashed #ccc;" class="py-2">
					<v-col cols="12" md="2" class="d-flex align-center justify-center">
						<img class="" style="border-radius: 50%;height: 50px;" :src="require('@/assets/dummy-profile-grey.png')">
						</img>
					</v-col>
					<v-col cols="12" md="6" class="pr-0">
						<div class="text-right">{{ tp.user?.fullName }}</div>
						<div class="text-right">
							<small class="grey--text">کد ملی:</small>
							<small class="grey--text">{{ tp.user?.nationalCode }}</small>
						</div>
						<div class="text-right mt-1" v-if="tp.isSigned">
							<v-chip small color="success" outlined>
								<v-icon left small>mdi-check-circle</v-icon>
								امضا شده
							</v-chip>
						</div>
					</v-col>
					<v-col cols="12" md="4" class="d-flex flex-column align-center justify-center">
						<v-btn small outlined color="secondary" @click="openGuarantorContract(tp)" class="mb-2" width="150">
							<v-icon left small>mdi-eye-outline</v-icon>
							مشاهده قرارداد
						</v-btn>
						<v-btn v-if="!tp.isSigned" small outlined color="secondary" class="mb-2" @click="openEditGuarantor(tp)" width="150">
							<v-icon left small>mdi-account-outline</v-icon>
							تغییر ضامن
						</v-btn>
						<v-btn :disabled="tp.isSigned" small outlined color="secondary" @click="removeGuarantor(tp)" width="150">
							<v-icon left small>mdi-trash-can-outline</v-icon>
							حذف ضامن
						</v-btn>
					</v-col>
				</v-row>
			</div>
			<div v-else class="text-center my-3">
				<div class="red--text mb-2">ضامن تعیین نشده است.</div>
			</div>
			<div class="text-center mt-5">
				<v-btn small outlined color="primary" @click="openAddGuarantor" width="200">
					<v-icon left small>mdi-plus</v-icon>
					{{ guarantors.length ? 'افزودن ضامن' : 'انتخاب ضامن' }}
				</v-btn>
			</div>
		</div>

		<v-dialog v-model="contractDialog" max-width="1600px">
			<v-card color="#eee">
				<v-card-title>
					<div>
						<span class="headline">اطلاعات قرارداد</span>
					</div>
					<v-spacer />
					<v-btn @click="contractDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<ContractDetail v-if="contractDialog" :area="area" :auth="auth" :mobile="contractMobile" :role="contractRole" :thirdPersonAssuranceAuthorizationItem="contractThirdPerson" @updated="$emit('updated')" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="manualDialog" max-width="500px" scrollable>
			<v-card>
				<v-card-title>
					<div>
						<span class="headline">اطلاعات دستی قرارداد</span>
					</div>
					<v-spacer />
					<v-btn @click="manualDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<div v-if="manualFields.length" class="mt-5">
						<v-text-field v-for="(field, index) in manualFields" :key="field.id || index" v-model="field.value" :label="field.label" dense outlined />
					</div>
					<div v-else class="text-center grey--text">
						موردی برای نمایش وجود ندارد.
					</div>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer />
					<v-btn text @click="manualDialog = false">
						بستن
					</v-btn>
					<v-btn color="secondary" :loading="submitManualTagsLoading" @click="submitManualTags">به روز رسانی متن قرارداد</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="selectMemberDialog" max-width="750px">
			<v-card color="#eee">
				<v-card-title>
					<div>
						<span class="headline">انتخاب ضامن</span>
					</div>
					<v-spacer />
					<v-btn @click="selectMemberDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<v-row class="justify-center">
						<v-col cols="12" md="6">
							<v-form @submit.prevent="searchMember">
								<div class="mt-4">
									<div>
										<strong class="red--text">کد ملی</strong>
										شخص مورد نظر را وارد نمایید:
									</div>
								</div>
								<v-text-field class="mb-4" compact ref="nationalCode" v-model="searchPhrase" maxlength="10" label="" :error-messages="errorMessages" :rules="[() => !!searchPhrase || 'اطلاعات را وارد کنید']" required />
								<v-alert class="mb-2 mt-2" type="error" outlined v-if="searchMessage">
									{{ searchMessage }}
								</v-alert>
								<v-btn color="primary" type="submit" :loading="searchLoading" block>
									جستجوی شخص
								</v-btn>
							</v-form>
						</v-col>
					</v-row>
					<div v-if="members !== null" style="padding: 10px;margin-top: 25px;">
						<v-alert v-if="!members.length" outlined type="error" icon="mdi-closews">
							<div class="text-center mb-2">
								شخصی با مشخصات وارد شده یافت نشد.
							</div>
							<div class="text-center">
								<v-btn color="primary" class="" :loading="!!selectedMemberId" @click="modifyThirdPersonDialog = true">ثبت مشخصات ضامن</v-btn>
							</div>
						</v-alert>
						<v-row v-for="(member, index) in members" :key="index" style="border-bottom: 1px dashed #eee;" class="justify-center">
							<v-col cols="12" sm="6">
								<v-card color="#fff" class="pa-2">
									<div class="mb-1 text-center">
										<img class="" style="border-radius: 50%;height: 70px;" :src="require('@/assets/dummy-profile-grey.png')">
										</img>
									</div>
									<div class="text-center secondary--text" style="font-size: 14px;">
										{{ member.fullName }}
									</div>
									<div class="text-center grey--text mb-2">
										کد ملی: {{ member.nationalCode }}
									</div>
									<div class="d-flex flex-wrap justify-center">
										<v-btn small color="info" class="mx-1 mb-1" @click="selectMember(member)" :loading="selectedMemberId === member.id">انتخاب</v-btn>
									</div>
								</v-card>
							</v-col>
						</v-row>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="modifyThirdPersonDialog" max-width="500px" scrollable>
			<ModifyThirdPersonAssurance v-if="modifyThirdPersonDialog" :area="area" @callbck="modifyThirdPersonAssuranceCallbck" @close="modifyThirdPersonDialog = false" />
		</v-dialog>

		<v-dialog v-model="sendSmsLinkAlertDialog" max-width="450px" scrollable>
			<v-card>
				<v-card-title>
					<div>
						<span class="headline">توجه</span>
					</div>
					<v-spacer />
					<v-btn @click="sendSmsLinkAlertDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text>
					<div class="text-justify red--text">
						کاربر گرامی، پیامک حاوی لینک امضای قرارداد برای ضامن ارسال شد.
						در صورت ارسال نشدن پیامک، ضامن می تواند با مراجعه به پنل کاربری خود در این سایت و ورود با کدملی
						به عنوان نام کاربری و کلمه عبور
						اقدام به امضای قرارداد نماید.
					</div>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer />
					<v-btn color="primary" @click="sendSmsLinkAlertDialog = false">
						متوجه شدم
					</v-btn>
					<v-spacer />
				</v-card-actions>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />

	</div>
</template>

<script>
import api from '@/util/app-api'
import { get } from 'vuex-pathify'
import toast from '@/util/toast'
import { auth } from '@/store/modules'
import { cloneDeep } from 'lodash'

export default {
	name: 'DigitalSignContract',
	props: {
		member: { type: Object, default: null },
		auth: { type: Object, default: null },
		area: { type: String, default: 'member' },
	},
	data() {
		return {
			modifyThirdPersonDialog: false,
			selectedMemberId: null,
			members: null,
			searchLoading: false,
			searchMessage: '',
			errorMessages: '',
			searchPhrase: '',
			submitManualTagsLoading: false,
			manualDialog: false,
			selectMemberDialog: false,
			contractDialog: false,
			manualFields: [],
			mobilee: '',
			contractRole: 'customer',
			contractThirdPerson: null,
			editingThirdPerson: null,
			sendSmsLinkAlertDialog: false
		}
	},
	components: {
		ConfirmDlg: () => import('@/components/Confirm'),
		Countdown: () => import('@/components/Countdown'),
		ContractDetail: () => import('@/components/loanAuthorizations/ContractDetail'),
		ModifyThirdPersonAssurance: () => import('@/components/forms/ModifyThirdPersonAssurance')
	},
	computed: {
		authorizationDescription() {
			return (this.auth && this.auth.authorizationItem && this.auth.authorizationItem.description) || ''
		},
		guarantors() {
			return (this.auth && this.auth.thirdPersonAssuranceAuthorizationItems) || []
		},
		mobile() {
			return this.mobilee || this.member?.mobile || 'نامشخص'
		},
		contractMobile() {
			return this.contractRole === 'guarantor' ? (this.contractThirdPerson?.user?.mobile || '') : this.mobile
		}
	},
	watch: {
		authorizationDescription: {
			immediate: true,
			handler(description) {
				this.extractManualFields(description)
			}
		}
	},
	mounted() {
		if (this.area === 'member')
			this.loadMemberMobile()
	},
	methods: {
		loadMemberMobile() {
			api.get('member/user/get/', null)
				.then(
					response => {
						this.mobilee = response.mobile
					})
				.catch(err => {
					toast.error(err.message)
				})
		},
		extractManualFields(description) {
			const fields = []
			if (!description) {
				this.manualFields = fields
				return
			}
			const regex = /\{manual:"([^"]+)"\}/g
			const prevFields = this.manualFields || []
			let match
			while ((match = regex.exec(description)) !== null) {
				const label = match[1]
				const index = fields.length
				fields.push({
					id: `${match.index}-${label}-${index}`,
					label,
					value: prevFields[index]?.value || ''
				})
			}
			this.manualFields = fields
		},
		fillManualFieldsFromSiteContent() {
			if (!Array.isArray(this.manualFields))
				return
			const data = {
				keys: this.manualFields.map(x => `${this.auth?.id}_${x.label}`)
			}
			api.post('admin/SiteContent/ListbyKeys', data)
				.then(response => {
					this.manualFields.forEach(item => {
						item.value = response.find(x => x.key === `${this.auth?.id}_${item.label}`)?.content || item.value
					})
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(() => {
				})
		},
		openCustomerContract() {
			this.contractRole = 'customer'
			this.contractThirdPerson = null
			this.contractDialog = true
		},
		openGuarantorContract(tp) {
			this.contractRole = 'guarantor'
			this.contractThirdPerson = tp
			this.contractDialog = true
		},
		openAddGuarantor() {
			if (this.guarantors?.length >= 3) {
				toast.error('در حال حاضر امکان ثبت بیش از 3 ضامن وجود ندارد.')
				return
			}
			this.editingThirdPerson = null
			this.resetSearch()
			this.selectMemberDialog = true
		},
		openEditGuarantor(tp) {
			this.editingThirdPerson = tp
			this.resetSearch()
			this.selectMemberDialog = true
		},
		resetSearch() {
			this.searchPhrase = ''
			this.searchMessage = ''
			this.errorMessages = ''
			this.members = null
		},
		searchMember() {
			this.searchMessage = ''
			if (!this.searchPhrase) {
				this.searchMessage = 'ابتدا عبارت مورد نظر جهت جستجو را وارد کنید'
				return
			}
			this.searchLoading = true
			api.get(`${this.area}/member/GetByNationalCode/` + this.searchPhrase, null)
				.then(response => {
					this.members = !response || response?.id === 0 ? [] : [response]
				})
				.catch(err => {
					this.searchMessage = err.message
				})
				.finally(() => this.searchLoading = false)
		},
		submitManualTags() {
			this.submitManualTagsLoading = true
			const manualFieldsObj = this.manualFields.reduce((acc, field) => {
				acc[field.label] = field.value
				return acc
			}, {})
			api.post('admin/UserLoanRequestAuthorizationItem/UpdateDigitalSignDescription/', { manualFields: manualFieldsObj, userLoanRequestAuthorizationItemId: this.auth.id })
				.then(response => {
					this.manualDialog = false
					toast.success('اطلاعات قرارداد با موفقیت ثبت شد.')
					this.$emit('updated')
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(() => {
					this.submitManualTagsLoading = false
				})
		},
		selectMember(member) {
			this.selectedMemberId = member.id
			const action = this.editingThirdPerson ? 'edit' : 'create'
			let data = {
				userLoanRequestAuthorizationItemId: this.auth.id,
				user: member,
				authorizationItemId: this.auth.authorizationItem.id
			}
			if (this.editingThirdPerson)
				data.id = this.editingThirdPerson.id
			api.post(`${this.area}/ThirdPersonAssuranceAuthorizationItem/${action}`, data)
				.then(response => {
					this.selectMemberDialog = false
					this.$emit('updated')
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(() => {
					this.selectedMemberId = ''
				})
		},
		modifyThirdPersonAssuranceCallbck(data) {
			this.modifyThirdPersonDialog = false
			if (data)
				this.selectMember({ id: data })
		},
		async removeGuarantor(item) {
			if (await this.$refs.confirm.open(
				'توجه',
				'آیا از حذف ضامن انتخاب شده مطمئن هستید؟',
			)) {
				api.post(`${this.area}/ThirdPersonAssuranceAuthorizationItem/delete/${item.id}`, {})
					.then(
						response => {
							toast.success('اطلاعات با موفقیت حذف شد.')
							this.$emit('updated')
						})
					.catch(err => {
						toast.error(err.message)
					})
			}
		},
	}
}
</script>
<style scoped>
.contract b {
	font-weight: 900;
	border-bottom: 1px dotted blue;
	color: blue;
}
</style>